import { Pipe, PipeTransform } from '@angular/core';
import { ParseDateService } from '../../../services/date/parse-date.service';

@Pipe({
    name: 'russianDateTime'
})
export class RussianDateTimePipe implements PipeTransform {

    constructor(private dateParseService: ParseDateService) {}

    transform(value: Date | string | number): string {
        if (!value) return '---';

        const localDate = new Date(this.dateParseService.changeTimeZone(value, ''));
        const now = new Date();

        const isToday =
            localDate.getDate() === now.getDate() &&
            localDate.getMonth() === now.getMonth() &&
            localDate.getFullYear() === now.getFullYear();

        const yesterday = new Date();
        yesterday.setDate(now.getDate() - 1);

        const isYesterday =
            localDate.getDate() === yesterday.getDate() &&
            localDate.getMonth() === yesterday.getMonth() &&
            localDate.getFullYear() === yesterday.getFullYear();

        const time = this.dateParseService.changeFormat(localDate,'HH:mm');

        console.log(time)
        if (isToday) {
            return `СЕГОДНЯ ${time}`;
        } else if (isYesterday) {
            return `ВЧЕРА ${time}`;
        } else {
            const day = this.dateParseService.changeFormat(localDate, 'DD.MM.YYYY');
            return `${day} ${time}`;
        }
    }
}
